// Existing deep links keep working when a record moves to its own home.
export const JOB_ANCHOR_ROUTES = {
  "job-diary": "diary",
  "job-needs": "needs",
  "job-materials": "materials",
  "job-photos": "photos",
  "job-commercial-files": "documents",
};

export function jobDestination(jobId, tab = "overview", { anchor = "", action = "", advanced = false } = {}) {
  const destination = JOB_ANCHOR_ROUTES[anchor] || tab;
  const params = new URLSearchParams();
  if (advanced) params.set("view", "advanced");
  if (action) params.set("action", action);
  return `/app/jobs/${encodeURIComponent(jobId)}/${destination}${params.size ? `?${params}` : ""}${anchor ? `#${anchor}` : ""}`;
}
